import React, { useState } from "react";
import images from "../../../Utils/importImages";
import showPasswordIcon from "../../../Assets/Images/show-passsword.svg"
import hidePasswordIcon from "../../../Assets/Images/hide-password.svg"

function PasswordDetail({ passwordDetail, setEditPasswordDetail }) {

  let [showPassword , setshowPassword] = useState(false);
  
  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>Password</h3>
        <div className="editable-profile-action">
          <div className="editable-profile-action">
            Edit <img src={images["edit-profile-details.svg"]} alt="" onClick={() => setEditPasswordDetail(true)}/>
          </div>
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li>
          <label for="">Password</label>
          <div className="userdb-edit">
            <div className="myprofile-general-value password">
              {showPassword ? passwordDetail.password : "▪▪▪▪▪▪▪▪▪▪▪▪"}
            <img src={showPassword ? showPasswordIcon : hidePasswordIcon} alt="" onClick={() => setshowPassword(!showPassword)} />
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default PasswordDetail;
